import React from 'react'
import { Grid, Stack } from '@mui/material'
import { UseFormReturn } from 'react-hook-form'
import CardActions from '../../../components/CardActions'
import { SectionBox } from '../../../components/FieldView'
import { ControlledTextField, ControlledDatePicker } from "../../../../../components/forms";
import { OperacionNOTESFields } from '../types/fields';
import SeccionNOTESNuevoSeccionCupon from './SeccionNOTESNuevoSeccionCupon'
import SeccionNOTESNuevoRescateAnticipado from './SeccionNOTESNuevoRescateAnticipado'
import SeccionNOTESNuevoSeccionParticipacion from './SeccionNOTESNuevoSeccionParticipacion'

interface SeccionNuevoNOTESDatosSeccionesProps {
  formMethods: UseFormReturn<any>
}

const SeccionNuevoNOTESDatosSecciones = ({ formMethods }: SeccionNuevoNOTESDatosSeccionesProps) => {
  const { control } = formMethods

  return (
    <Stack gap={2}>
      <CardActions title='Sección - Información General' icon='mdi:information-outline' colapsable>
        <SectionBox>
          <Grid item xs={12} >
            <ControlledTextField label='País' name={OperacionNOTESFields.NombrePais} control={control} fullWidth />
          </Grid>
          <Grid item xs={12} >
            <ControlledTextField label='Tipo de Nota' name={OperacionNOTESFields.TipoNota} control={control} fullWidth />
          </Grid>
          <Grid item xs={12} >
            <ControlledTextField label='Capital a suscribir' name={OperacionNOTESFields.CapitalASuscribir} control={control} fullWidth />
          </Grid>
          <Grid item xs={12} >
            <ControlledTextField label='Moneda' name={OperacionNOTESFields.Moneda} control={control} fullWidth />
          </Grid>
          <Grid item xs={12} >
            <ControlledTextField label='Vencimiento' name={OperacionNOTESFields.Vencimiento} control={control} fullWidth />
          </Grid>
          <Grid item xs={12} >
            <ControlledDatePicker label='Fecha de Emisión' name={OperacionNOTESFields.FechaEmision} control={control} />
          </Grid>
          <Grid item xs={12}>
            <ControlledTextField label='Emisor' name={OperacionNOTESFields.Emisor} control={control} fullWidth />
          </Grid>
        </SectionBox>
      </CardActions>

      <CardActions title='Sección Sub-yacentes' icon='mdi:chart-scatter-plot' colapsable>
        <SectionBox>
          <Grid item xs={12}>
            <ControlledTextField label='Subyacentes' name={OperacionNOTESFields.Subyacentes} control={control} fullWidth />
          </Grid>
          <Grid item xs={12}>
            <ControlledTextField label='Observaciones adicionales' name={OperacionNOTESFields.ObsSubyacentes} control={control} fullWidth multiline rows={2} />
          </Grid>
        </SectionBox>
      </CardActions>

      <SeccionNOTESNuevoSeccionCupon formMethods={formMethods} />

      <SeccionNOTESNuevoRescateAnticipado formMethods={formMethods} />

      <SeccionNOTESNuevoSeccionParticipacion formMethods={formMethods} />


      <CardActions title='Sección Protección de Capital' icon='mdi:shield-outline' colapsable>
        <SectionBox>
          <Grid item xs={12} >
            <ControlledTextField label='Tipo de protección' name={OperacionNOTESFields.TipoProteccion} control={control} fullWidth />
          </Grid>
          <Grid item xs={12} >
            <ControlledTextField label='Nivel de protección' name={OperacionNOTESFields.NivelProteccion} control={control} fullWidth />
          </Grid>
          <Grid item xs={12} >
            <ControlledTextField label='Descripción de la protección' name={OperacionNOTESFields.DescripcionProteccion} control={control} fullWidth />
          </Grid>
          <Grid item xs={12}>
            <ControlledTextField label='Observaciones adicionales' name={OperacionNOTESFields.ObsProteccion} control={control} fullWidth multiline rows={2} />
          </Grid>
        </SectionBox>
      </CardActions>


    </Stack>
  )
}

export default SeccionNuevoNOTESDatosSecciones
